import { MenuItem } from "@blueprintjs/core"
import ActionMenu from "components/Atoms/ActionMenu"
import CustomCard from "components/Atoms/CustomCard"
import NewTag from "components/Atoms/NewTag"
import StyledLink from "components/Atoms/StyledLink"
import ReactTableHeader from "components/Common/ReactTableHeader"
import TablePagination from "components/Molecules/TablePagination"
import NewResourceButton from "components/Organisms/AddResourceButton"
import SerialColumn from "components/Organisms/table/SerialColumn"
import CustomReactTable from "components/Templates/CustomReactTable"
import { useAllSkuTypesListQuery } from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React from "react"
import { useNavigate } from "react-router-dom"

const Cell = ({ text, unit }) => {
  return (
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      <span style={{ width: "48%", textAlign: "right" }}>{text}</span>
      <span style={{ width: "4%" }}></span>
      <span style={{ width: "48%", textAlign: "left", fontWeight: "bold" }}>
        {unit}
      </span>
    </div>
  )
}
export default function Skus() {
  const navigate = useNavigate()
  const COLUMNS = [
    SerialColumn,
    {
      accessor: "actions",
      maxWidth: 50,
      Cell: ({ original: row }) => {
        return (
          <ActionMenu>
            <MenuItem
              icon="edit"
              text="Edit Sku"
              onClick={e => navigate(row?.id)}
            />
          </ActionMenu>
        )
      },
    },
    {
      Header: "Name",
      accessor: "name",
      Cell({ value, original }) {
        return (
          <>
            <StyledLink to={original.id}>{value}</StyledLink>
            <NewTag createdAt={original.createdAt} />
          </>
        )
      },
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Capacity",
      accessor: "capacity",
      Cell: ({ value, original }) => {
        return <Cell text={value} unit={original.capacityUnit.name}></Cell>
      },
    },
    {
      Header: "Category",
      accessor: "skuCategory",
      Cell: ({ value }) => {
        return (
          <Cell
            text={value && value.name}
            unit={value && value.codename}
          ></Cell>
        )
      },
    },
    {
      Header: "Dimensions (l x b x h)",
      accessor: "dimensions",
      className: "text-center",
      maxWidth: 250,
      Cell({ value, original }) {
        const siUnit = original?.dimensionUnit
        return <Cell text={value?.join(" x ")} unit={siUnit?.codename} />
      },
    },
    {
      Header: "Tare Weight (Kg)",
      className: "text-center",

      accessor: "selfWeight",
    },

    {
      Header: "Stock Count",
      className: "text-center",

      accessor: "stockCount",
    },
    {
      Header: "Idle",
      accessor: "harvestGrades",
      width: 140,
    },
  ]
  const [{ search, page }, setFilter] = useSearchFilter()
  const { data, loading, error } = useAllSkuTypesListQuery({
    variables: {
      first: 13,
      skip: page * 13,
      query: search,
    },
  })
  const list = data?.allSkuTypes || []
  if (error) return <>{`error ${error.message}`}</>
  return (
    <CustomCard className="p-0">
      <ReactTableHeader
        icon="box"
        title="SKUs"
        onQueryChange={query => {
          setFilter({
            search: query,
            page: 0,
          })
        }}
      >
        <TablePagination
          className="mr-6"
          page={page}
          onPageChange={page => {
            setFilter({
              page,
            })
          }}
        />
        <NewResourceButton module="sku" text="SKU" />
      </ReactTableHeader>
      <CustomReactTable
        loading={loading}
        showPagination={false}
        data={list}
        columns={COLUMNS}
      />
    </CustomCard>
  )
}
